import * as React from 'react';

import { cn } from '@/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onFocus, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-lg border border-border bg-panel px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground hover:bg-raised/60 focus-visible:outline-none focus-visible:border-gold focus-visible:ring-2 focus-visible:ring-gold/20 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
          type === 'number'
            ? 'appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
            : '',
          className
        )}
        ref={ref}
        onFocus={(e) => {
          if (type === 'number' && e.target.value === '0') {
            e.target.value = '';
          }
          onFocus?.(e);
        }}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
